import { createSvgIcon } from "@mui/material";

export const CloseIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
        <path d="M0.999995 9.48529L9.48528 1M0.999995 1L9.48528 9.48529" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'CloseIcon'
)
